import React from 'react';
import { Typography, Box } from '@mui/material';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import LockIcon from '@mui/icons-material/Lock';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';  // New Icon for Step 2

const FormTitle = ({ formType, Forgetstep, step, t }) => {
    const getIcon = () => {
        if (formType === "forget-password" && Forgetstep === 3) {
            return <LockIcon sx={{ fontSize: '30px', color: '#12538B' }} />;
        } else if (formType === "forget-password" && Forgetstep === 2) {
            return <CheckCircleIcon sx={{ fontSize: '30px', color: '#12538B' }} />;  // New Icon for Step 2
        } else if (formType === "forget-password") {
            return <FingerprintIcon sx={{ fontSize: '30px', color: '#12538B' }} />;
        }
        return null;
    };

    const getTitle = () => {
        if (formType === "forget-password" && Forgetstep === 3) {
            return t.resetPassword;
        } else if (formType === "forget-password" && Forgetstep === 2) {
            return t.enterResetCode;  // Title for Step 2
        } else if (formType === "forget-password") {
            return t.forgetPassword;
        } else if (formType === "signin") {
            return t.welcomeBack;
        } else if (step !== 4 && step !== 5) {
            return t.signUpTitle;
        }
        return "";
    };
    return (
        <Typography
            variant="h4"
            sx={{
                fontWeight: "bold",
                marginBottom: "16px",
                textAlign: "center",
                fontSize: { xs: "1.5rem", md: "2.5rem" },
                color: "#12538B",
                mt: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center", // Center content horizontally
                justifyContent: "center", // Center content vertically
            }}
        >
            {/* Display Icon */}
            {getIcon() && (
                <Box
                    sx={{
                        width: '40px',
                        height: '40px',
                        border: '1px solid #C7C7C780',
                        borderRadius: '5px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: "center",
                        mb: "24px", // margin below the icon
                    }}
                >
                    {getIcon()}
                </Box>
            )}

            {/* Display Title */}
            {getTitle()}
        </Typography>
    );
};

export default FormTitle;
